export const IMPERSONATE_AUTH_TOKEN = 'impersonatedAuthToken';
export const IMPERSONATED_EXPIRES_IN = 'impersonatedExpiresIn';
export const IS_IMPERSONATION_MODE_ON = 'isImpersonationModeOn';
export const IMPERSONATED_LOCALE_ID = 'imperson_localeID';
export const IMPERSONATED_USER_INFO_TOKEN = 'imperson_userInfo';
export const IMPERSONATED_USER_EMAIL = 'impersonatedUserEmail';
export const EXPIRES_IN = 'expires_in';
export const USERID_TOKEN = 'userid_token';

export function getTokensFromLocalStorage() {
  const impersonateMode = localStorage.getItem(IS_IMPERSONATION_MODE_ON) == 'true';

  if (!impersonateMode) {
    return localStorage;
  } else {
    return {
      expires_in: localStorage.getItem(IMPERSONATED_EXPIRES_IN) || '',
      userid_token: localStorage.getItem(IMPERSONATE_AUTH_TOKEN) || '',
      localeId: localStorage.getItem(IMPERSONATED_LOCALE_ID) || '',
      userInfo: localStorage.getItem(IMPERSONATED_USER_INFO_TOKEN) || '',
      currencySymbolsMap: localStorage.getItem('currencySymbolsMap'),
      USER_SETTINGS: localStorage.getItem('USER_SETTINGS'),
    };
  }
}

export function isImpersonationModeOn() {
  return localStorage.getItem(IS_IMPERSONATION_MODE_ON) == 'true';
}
